import React from "react";
export default {
  en: {
    anotherCard: 'Another card',
    cardName: {
      placeHolder: 'Card',
      label: 'Card'
    },
    endingIn: 'ending in',
    expiration: 'Expiration',
    lastDigits: 'Termination',
    edit: 'Edit',
    delete: 'Delete',
    from: 'From',
    to: 'to',
    toMayus: 'To',
    accountSettings: {
      myInfo: 'My Info',
      tickets: 'My Tickets',
      ticketsTitle: 'Tickets',
      noTickets: 'No tickets available',
      creditCard: 'My Payments',
      companions: 'My Companions',
      vehicles: 'My Vehicles',
      ticketsInfo: 'Here is your purchase history.',
      myCompanions: 'Other Travelers in my group',
      companionsInfo:
        'Enter the information of other travelers in your group to receive exclusive offers.',
      addCompanion: 'Add Traveler',
      editCompanion: 'Edit Traveler',
      deleteCompanion: 'Are you sure you want to delete this Traveler',
      deleteCard: 'Are you sure you want to delete this payment method?',
      myCards: 'Credit and debit cards',
      myCardsInfo: 'Add or edit payment method for quicker purchases.',
      addPayment: 'Add Payment method',
      editPayment: 'Edit Payment method',
      searchTickets: 'Search by ticket ID',
      checkTerms: 'Terms & conditions',
      noResult: "We couldn't find a ticket with that ID",
      noResults: "We couldn't find tickets with those IDs",
      noResultsFilter: "We couldn't find tickets matching those filters",
      savedPaymments: 'Saved Payment Methods',
      chooseACreditCard: 'Choose a card'
    },
    shoppingHistory: 'Shopping History',
    infoUpdated: '✓ Your info was updated',
    loginAgainMessage: 'Please enter your old credentials',
    saveChanges: 'Save changes',
    logOut: 'Logout',
    greetings: 'Hello',
    greetingsMessage: 'Update your info',
    contactUs: 'Contact',
    myAccount: 'My profile',
    myCart: 'My cart',
    myTrip:'My trip',
    updateTicket: 'Update Information',
    ticketUpdateSuccessful: 'Ticket Information Updated Successfully',
    ticketUpdateError: 'An error ocurred updating ticket information. Please try again later.',
    alreadyLogged: 'You are already logged in,',
    alreadyLoggedMessage: 'click here to logout',
    forgotYourPassword: 'Forgot your password?',
    loginMessage: 'Sign In',
    'auth/user-not-found': 'email address not found',
    'auth/email-already-in-use':
      'The email address is already in use by another account.',
    'auth/invalid-email': 'The email address is not valid',
    'auth/wrong-password': 'Incorrect password',
    defaultUserError:
      'There was an error with your information, please try again',
    logIn: 'Login',
    alreadyHaveAnAccount: 'Already have an account?',
    createYourAccount: 'Create your CBX profile',
    signUpHelper:
      'Make your purchase easier and faster by creating your profile. Access your purchase history, update information and add other travelers in your group.',
    acceptTermsRegister: ['By checking this box and creating a CBX profile, you agree to our ', <a  target="_blank" rel={"noopener noreferrer"} style={{color: "#ef60a3"}} href="/en/terms">Terms and Conditions</a>, '. You further understand and acknowledge that your information will be used and treated as described in our ', <a style={{color:"#ef60a3"}} target="_blank" rel={"noopener noreferrer"} href="/en/privacy">Privacy Policy</a>, '.'],
    checkboxDonate: 'Yes! I’d like to donate $1 to CBX\'s Warm Hearts Warm Meals campaign to support the fight against hunger in Tijuana in cooperation with ',
    donateTitle: 'Yes! I’d like to donate',
    donateText: 'to providing food security for vulnerable families at the U.S.-Mexico Border through the  ',
    donateText2: 'Warm Hearts Warm Meals',
    donateText3: 'matching grant campaign.',
    modalDonate: 'Throughout the month of September, CBX and This is About Humanity will each match donations received up to $20,000. With your donation you can help us provide food security to those most in need.',
    signUp: 'Create profile',
    country: 'Country',
    errorMessage:
      'There was a system error, please try again in a few minutes. If you are unable to complete this purchase please contact us.',
    errorCreditCard:
      'There was an issue with your payment information, please try again.',
    errorInput: 'Please verify your details are correct.',
    errorConnection:
      'There has been an error in your purchase, the charge has not been made please try again.',
    errorTickets:
      ['We experienced a problem while sending your ticket. Please contact us via email to: ', <a style={{ color: 'rgb(239, 96, 163)' }} href="mailto:support@crossborderxpress.com">support@crossborderxpress.com</a>, ' in order to review your transaction and the detected error.'],
    shoppingError:
      'An error has ocurred!',
    downloadTicket: 'Download Ticket',
    downloadTicketInfo:
      'A copy of your CBX ticket was sent to ',
    quantity: 'Quantity',
    people: 'People',
    contactInformation: 'Contact Information',
    purchaseSummary: 'Purchase summary',
    flightInformation: 'Flight Information',
    paymentInformation: 'Payment Information',
    departDate: 'Departure Date',
    returnDate: 'Return Date',
    cancelLabel: 'Cancel',
    myTrip:"My trip",
    continueLabel: 'Continue',
    originLabel: 'From',
    destinationLabel: 'To',
    LoginButton: 'LogIn',
    signInComplementaryText: 'Make your purchase experience faster',
    createCBXAccount: 'Create your CBX profile',
    buyLabel: 'Buy',
    rfc: {
      placeHolder: 'RFC',
      label: 'RFC'
    },
    name: {
      placeHolder: 'Name',
      label: 'Name'
    },
    lastName: {
      placeHolder: 'Last name',
      label: 'Last Name'
    },
    email: {
      placeHolder: 'Email address',
      label: 'Email'
    },
    emailCheck: {
      placeHolder: 'Confirm your email address',
      label: 'Confirm your email'
    },
    zipCode: {
      placeHolder: 'ZIP Code',
      label: 'ZIP Code'
    },
    phone: {
      placeHolder: 'Phone',
      label: 'Phone'
    },
    creditCardHolder: {
      placeHolder: 'Name on card',
      label: 'Name on card'
    },
    creditCard: {
      placeHolder: '4111 1111 1111 1111',
      label: 'Card Number'
    },
    ccv: {
      placeHolder: 'CVV',
      label: 'CVV'
    },
    expirationDate: {
      placeHolder: 'MM / YY',
      label: 'Expiration Date'
    },
    creditCardZipCode: {
      placeHolder: '11111',
      label: 'Postal Code'
    },
    creditCardZipCodeSmall: {
      placeHolder: 'Zip',
      label: 'Zip'
    },
    isInvalid: ' is invalid.',
    isIncomplete: ' is incomplete.',
    acceptTerms: {
      label: 'I agree to CBX terms of use.'
    },
    acceptMailInfo: {
      label: 'I would like to receive information and promotions about CBX.'
    },
    password: {
      placeHolder: 'Password',
      label: 'Password'
    },
    checkPassword: {
      placeHolder: 'Confirm Password',
      label: 'Confirm Password'
    },
    shoppingLabels: {
      transaction: 'Sale ID',
      detail: 'Ticket Type',
      type: 'Travel',
      passengers: 'Passengers',
      invoice: 'Invoice',
      date: 'Date',
      product: 'Product',
      price: 'Cost',
      ticketLabel: 'Ticket',
      roundtrip: 'Round Trip',
      oneway: 'One way',
      single: 'Single',
      family: 'Family',
      typeOptions: [
        {
          name: 'Type',
          value: ''
        },
        {
          name: 'One Way',
          value: 'oneway'
        },
        {
          name: 'Round Trip',
          value: 'roundtrip'
        }
      ],
      detailOptions: [
        {
          name: 'Detail',
          value: ''
        },
        {
          name: 'Single',
          value: 'single'
        },
        {
          name: 'Family',
          value: 'family'
        }
      ]
    },
    invoice: {
      sendMessage: 'Thank you, we have received your information. This is not an automated system, the invoice will be sent in a period of 5 to 7 business days.',
      error: 'There was an error with your invoice information',
      title: 'Invoicing',
      instructions:
        'To process your invoice we require the following information:',
      terms:
        'Invoices must be requested within 15 business days from original date of purchase.',
      rfc: {
        label: 'RFC',
        placeHolder: 'RFC (Mexican TAX ID Number)'
      },
      company: {
        label: 'Name or Company',
        placeHolder: 'Name or Company'
      },
      ticketNumber: {
        label: 'CBX Ticket Number',
        placeHolder: 'CBX Ticket Number'
      },
      ticketDate: {
        label: 'Ticket Date',
        placeHolder: 'DD / MM / YY'
      },
      ticketPrice: {
        label: 'Ticket Price',
        placeHolder: 'Ticket Price'
      },
      saleId: {
        label: 'Sales ID',
        placeHolder: 'Sales ID'
      },
      purchaseTicket: {
        label: 'Purchase Ticket',
        placeHolder: 'Purchase Ticket',
      },
      company_zip_code: {
        label: 'Registered Business Zip Code',
        placeHolder: 'Zip Code'
      },
      receipt: {
        label: 'Receipt',
        placeHolder: 'Receipt'
      },
      paymentMethod: {
        label: 'Payment Method',
        options: [
          {
            name: 'Select your payment method',
            value: ''
          },
          {
            name: 'Cash',
            value: 'cash'
          },
          {
            name: 'Credit Card',
            value: 'creditCard'
          },
          {
            name: 'Debit Card',
            value: 'debitCard'
          }
        ]
      },
      businessType: {
        label: 'Business Type',
        options: [
          {
            name: 'Select a Business Type',
            value: ''
          },
          {
            name: 'General de Ley Personas Morales',
            value: '601 - General de Ley Personas Morales'
          },
          {
            name: 'Personas Morales con Fines no Lucrativos',
            value: '603 - Personas Morales con Fines no Lucrativos'
          },
          {
            name: 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
            value: '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios'
          },
          {
            name: 'Arrendamiento',
            value: '606 - Arrendamiento'
          },
          {
            name: 'Demás ingresos',
            value: '608 - Demás ingresos',
          },
          {
            name: 'Consolidación',
            value: '609 - Consolidación',
          },
          {
            name: 'Residentes en el Extranjero sin Establecimiento Permanente en México',
            value: '610 - Residentes en el Extranjero sin Establecimiento Permanente en México'
          },
          {
            name: 'Ingresos por Dividendos (socios y accionistas)',
            value: '611 - Ingresos por Dividendos (socios y accionistas)',
          },
          {
            name: 'Personas Físicas con Actividades Empresariales y Profesionales',
            value: '612 - Personas Físicas con Actividades Empresariales y Profesionales',
          },
          {
            name: 'Ingresos por intereses',
            value: '614 - Ingresos por intereses',
          },
          {
            name: 'Sin obligaciones fiscales',
            value: '616 - Sin obligaciones fiscales',
          },
          {
            name: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
            value: '620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
          },
          {
            name: 'Incorporación Fiscal',
            value: '621 - Incorporación Fiscal',
          },
          {
            name: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
            value: '622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
          },
          {
            name: 'Opcional para Grupos de Sociedades',
            value: '623 - Opcional para Grupos de Sociedades',
          },
          {
            name: 'Coordinados',
            value: '624 - Coordinados',
          },
          {
            name: 'Régimen Simplificado de Confianza',
            value: '626 - Régimen Simplificado de Confianza',
          },
          {
            name: 'Hidrocarburos',
            value: '628 - Hidrocarburos',
          },
          {
            name: 'Régimen de Enajenación o Adquisición de Bienes',
            value: '607 - Régimen de Enajenación o Adquisición de Bienes',
          },
          {
            name: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales',
            value: '629 - De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales',
          },
          {
            name: 'Enajenación de acciones en bolsa de valores',
            value: '630 - Enajenación de acciones en bolsa de valores',
          },
          {
            name: 'Régimen de los ingresos por obtención de premios',
            value: '615 - Régimen de los ingresos por obtención de premios'
          }
        ]
      },
    },
    ticketPromo: {
      placeHolder: 'Promo Code',
      label: 'Promo Code',
      messageNoPromo: 'The discount is not valid for the current package',
      status: {
        disabled: 'Validate Code',
        normal: 'Validate Code',
        error: 'Not a valid code',
        valid: 'Valid Code'
      }
    },
    savingData: 'Saving your data, please wait a moment...',
    savedData: 'Your data was saved succesfully',
    startDate: 'Start',
    endDate: 'End',
    startTime: 'Time',
    endTime: 'Time',
    parkingLabel: 'Reserve your parking',
    parkingButton: 'Book Now',
    parking: 'Parking',
    ticket: 'Ticket',
    numberOfTickets:'Select number of tickets',
    viewMore: 'View more',
    confirmParkingPage:'Confirm parking information',
    passengersLabel: 'Passengers',
    shuttleSelectDatesLabel:'Confirm shuttle information',
    shuttleFormDescription:'Please present your printed reservation to the driver, along with your goverment issued ID, upon boarding.',
    parkingSelectDatesLabel:'Select dates',
    startFormParking:'Start',
    endFormParking:'End',
    addRemovePlaces:'Add/Remove another car',
    selecDateLabel:'Select departure date and schedule',
    vehicleInformation:'Vehicle  reservation information',
    vehiclesNo: 'Reserved spots',
    maker:'Maker',
    model:'Model',
    year:'Year',
    color:'Color',
    state:'State',
    license:'License plate',
    continueParking:'Continue Shopping',
    editParking:"Edit",
    selectLot:'Select parking lot',
    lot:'lot',
    selectLabel:"Select",
    day:'day',
    infoLot:'Daily rates subject to change without prior notice',
    parkingSpaceLot:'Parking spaces:',
    manageTicketsTitle :"Manage your trip",
    typeInformationLabel:"Type  in the following information:",
    purchaseNumberLabel:"Purchase number",
    identityLabel: 'Email, last name, or phone number',
    forgotPurchaseNumber:"Forgot your purchase number?",
    shoppifasterLabel:"And make your shopping experience faster",
    enter:"Enter",
    cancel:"Cancelled",
    carRental:'Car rental',
    shuttle:"Shuttle",
    proceedCheckout: "Proceed to checkout",
    missingSomething:"Missing something?",
    addItems: "Keep adding items to your cart",
    emptyCart: "Your cart is empty",
    emptyAddItems: "Add items to your cart",
    diferentDatesLabel:"Attention",
    diferentDatesSubTitle:"The travel date and parking reservation date do not match. Make sure the dates are correct",
    apply:"Apply",
    remove:"Remove",
    purchase:"Purchase",
    thankYou:"Thank you!",
    successMessage:["We appreciate your purchase.", <br/>, "You will receive an e-mail confirmation with all your details."],
    forgotSomething:"Forgot something?",
    keepAdding:"Keep adding items to your cart",
    download:"Download ticket",
    downloadParking:"Download ticket (Parking)",
    downloadShuttle:"Download ticket (Shuttle)",
    downloadWheels:"Download ticket (Private Transportation)",
    wheelsDisclaimer: "The Wheels transportation service is operated by Mexicoach Inc., TCP 0036804. CBX is not a Charter-Party Carrier (TCP) and does not own or operate any buses, shuttles or vehicles for compensation or hire.",
    returnHome:"Return To Home",
    passenger:"Passenger ",
    baggage: "Baggage",
    shuttleSelectSeatsLabel: "Select seats",
    shuttleBaggageLabel: "Choose # of baggage",
    ticketLabel: "Ticket",
    travelPurpose:"Travel Purpose",
    confirm:"Confirm",
    addToCart:"Add to cart",
    ticketStep: "Ticket",
    passengerInformation: "Passenger information",
    addOns: "Add-ons",
    addOnsSubtitle:"Add more products",
    checkout: "Checkout",
    reserve_parking: "Reserve your parking",
    reserve_shuttle: "Reserve your shuttle",
    requestProcessing: "Processing...",
    requestDoNotClose: "Do not refresh this page.",
    requestSearching: "Searching Ticket...",
    titleTripLogin:"Manage your trip",
    typeInformation:"Type  in the following information",
    purchaseNumber:"Purchase Number",
    forgotInformation:"forgot your purchase number",
    createAccount:"Create a CBX account",
    fasterShoppingLabel:"And make your shopping faster",
    areYouSureCancel:"Are you sure you want to cancel this item?",
    cancellingHoursLabel:" We have a 24-hour cancellation policy, so you will only get a full refund if you cancel ahead of that period. The estimated time in which the refund is issued is 72 hours. If you cancel your reservation within 24 hours of its start time you will be issued a partial refund and charged for 1 day of reservation.",
    returnLabel:"Return",
    cancelItem:"Cancel this item",
    successCancellationTitle:"Your cancellation has been successful.",
    successCancellationDescription:"You will receive an email with the information",
    showErrorCancellationTitle:"Your cancellation cannot be processed",
    showErrorCancellationDescription:"For any questions, write to us at",
    ok:"Okay",
    parkingLabelCancel:"Parking",
    days:"Day",
    vehiclesLabel:" Vehicle",
    startDateLabel:"Start",
    startDateLabelTickets:"From",
    endDateLabelTickets:"To",
    endDateLabel:"End",
    cancelTheItem:"Cancel the item",
    hi:"Hi,",
    invalidEmail:"Invalid email",
    errorCredentials:'Invalid credentials',
    PurchaseDetailsLabel:"Purchase details",
    mainContact:"Main contact ",
    dateOfSale:"Date of Sale",
    salesId:"Sales ID",
    cardNumber:"Card Number ",
    total:"Total",
    contactUs:"Contact us",
    downloadTicket:"Download ticket",
    downloadTicketParking: 'Download parking',
    itemsInMyCart: 'Items in my cart',
    moreProducts: 'More of our products',
    sportsNotAvailableTitle: 'Please change your selection.',
    sportsNotAvailableLabel: 'Valet reservations are available at all times, but reservations in designated lots are fully booked for the selected dates.  We also offer plenty of self-parking options and valet services on site.',
    sportsNotAvailableButton: 'Check Parking Lots',
    assistPassName: 'Name',
    assistPassLastName: 'Last Name',
    assistPassGender: 'Gender',
    assistPassPhone: 'Phone',
    assistPassAge: 'Age',
    assistPassDate: 'Date',
    assistPassFightNumber: 'Flight Number',
    assistPassAirline: 'Airline',
    assistPassOrigin: 'Origin',
    assistPassDestination: 'Destination',
    assistPassTutorName: 'Name',
    assistPassTutorLastName: 'Last Name',
    assistPassTutorPhone: 'Phone',
    assistPassTutorEmail: 'Email',
    visa: 'Visa',
    passport: 'Passport',
    permit94: 'I-94 permit',
    unForm: 'UNMR form',
    samPermit: 'SAM',
    fmmPermit: 'FMM',
    notarizedPermit: 'Notarized Letter',
    filesToSubmit: 'Files to submit',
    tutorDescription: 'Tutor Information',
    flightDescription: 'Flight Information',
    onlyVolaris: 'Service only applies with Volaris',
    male: 'Male',
    female: 'Female',
    unspecified: 'Unspecified',
    genderSelected: 'Gender selected must match what appears on your passport/government-issued travel documents.',
    ageRangeunavailable: 'Age must be between 13 and 17. Service unavailable outside of this age range',
    emptyFile: 'Empty file',
    fileSelected: 'File selected!',
    collapse:'Collapse',
    expand:'Expand',
    search:'Search',
    whatCanWeHelpYouFind:'What can we help you find?',

    // shuttle
    selectTrip:"Select Trip",
    selectTripBack:"Select return trip",
    notInclude:"Does not include applicable fees.",
    details:"Details",
    serviceProvider:"Service provider",
    standarFare:"Standard fare",
    select: "Select",
    noTransfers: "NO TRANSFERS",
    transfers: " TRANSFER",
    withTransfers: "WITH TRANSFERS",
    depart: 'Departure',
    arrival :"Arrival",
    person: "per person ",
    selectYourSeat: "Select your seat",
    avalaibleSeat: "Available seats: ",
    available:"Available",
    occupied:"Occupied",
    selectSeat:"Select seat",
    seat :"Seat",
    attention:"Attention",
    shuttleNotAvailableTitle: 'We are sorry there are no shuttles available on the dates selected',
    shuttleNotAvailableLabel: 'Please try again with different dates',
    warnText:"Not all required seats are selected yet",
    loading: 'Loading',
    permit94Site: 'Visit official I-94 site',
    unFormSite: 'Download UNMR form',
    samPermitSite: 'Visit official SAM site',
    fmmPermitSite: 'Visit official FMM site',
    assistedPassDescription: 'Enter the following information as it appears on the government-issued ID or travel documents you´ll be traveling with',
    mex: 'Mexican',
    usa: 'American',
    other: 'Other',
    nationality: 'Nationality',
    IdTutor: 'ID Tutor',
    howWorks: 'Learn more about how ',
    unaccompaniedTeen: ' Unaccompanied Teen',
    assistedPass: ' Assisted Pass',
    works: 'works',
    return: 'Return',
    textShuttleQuickBook: 'Otay-Tijuana Venture, LLC is not a Charter-Party Carrier (TCP) nor Passenger Stage Corporation (PSC) and does not own or operate any buses, shuttles, or vehicles for compensation or hire.',
    convertion: '*This transaction will be charged in USD at the official exchange rate from Banxico.',
    reserveBundles: 'Reserve your bundle',
    bundles: 'Bundles',
    tickPlusShuttle: '25% off ticket + shuttle',
    configure: 'Configure',
    wheelsSelector: 'Private Transportation',
    reserve_wheels: 'Reserve Private Transportation',
    confirmWheelsPage: 'Reserve Private Transportation',
    selectedInsurance: 'If you selected travel medical protection, you will receive a separate email with your plan document.'
  },
  es: {
    anotherCard: 'Otra tarjeta',
    cardName: {
      placeHolder: 'Tarjeta',
      label: 'Tarjeta'
    },
    endingIn: 'terminación',
    expiration: 'Vence',
    lastDigits: 'Terminación',
    edit: 'Editar',
    delete: 'Eliminar',
    from: 'Desde',
    to: 'hacia',
    toMayus: 'Hacia',
    accountSettings: {
      myInfo: 'Mis datos',
      tickets: 'Mis boletos',
      ticketsTitle: 'Boletos',
      noTickets: 'No hay boletos disponibles',
      creditCard: 'Mis tarjetas',
      companions: 'Mis acompañantes',
      vehicles: 'Mis vehículos',
      ticketsInfo: 'Aquí encontrarás todos los boletos que has adquirido.',
      myCompanions: 'Acompañantes',
      companionsInfo:
        'Ingresa los datos de tus acompañantes de viaje para recibir ofertas exclusivas.',
      addCompanion: 'Agregar Acompañante',
      editCompanion: 'Editar Acompañante',
      deleteCompanion: '¿Estas seguro que quieres eliminar este acompañante?',
      deleteCard: '¿Estas seguro que quieres eliminar esta tarjeta?',
      myCards: 'Tarjetas',
      myCardsInfo:
        'Agrega o edita tu forma de pago para que compres de forma más rápida y segura.',
      addPayment: 'Agregar Tarjeta',
      editPayment: 'Editar Tarjeta',
      searchTickets: 'Buscar por ID de boleto',
      noResult: 'No se encontro un boleto con ese ID',
      noResults: 'No se encontraron boletos con esos IDs',
      noResultsFilter: 'No se encontraron boletos con esos filtros',
      savedPaymments: 'Tarjetas Guardadas',
      chooseACreditCard: 'Selecciona una tarjeta',
      checkTerms: 'Términos y condiciones'
    },
    shoppingHistory: 'Historial de compras',
    infoUpdated: '✓ Tu información se ha actualizado',
    loginAgainMessage: 'Por favor ingresa tus datos actuales',
    saveChanges: 'Guardar cambios',
    logOut: 'Cerrar sesión',
    greetings: 'Hola',
    greetingsMessage: 'Actualiza tus datos',
    contactUs: 'Contacto',
    myAccount: 'Mi cuenta',
    myCart: 'Carrito',
    myTrip:'Mis viajes',
    alreadyLogged: 'Ya cuentas con una sesión activa,',
    alreadyLoggedMessage: 'haz clic aqui para cerrar tu sesión actual',
    forgotYourPassword: '¿Olvidaste tu contraseña?',
    loginMessage: 'Iniciar sesión',
    'auth/user-not-found': 'La dirección no se encuentra registrada',
    'auth/email-already-in-use':
      'La dirección de correo ya se encuentra registrada',
    'auth/invalid-email': 'La dirección de correo no es valida',
    'auth/wrong-password':
      'Contraseña incorrecta, por favor intenta nuevamente',
    defaultUserError:
      'Hubo un error con tu información, por favor intenta nuevamente',
    ticketPromo: {
      placeHolder: 'Código',
      label: 'Código Promocional',
      messageNoPromo: 'El descuento no es valido para el paquete actual',
      status: {
        disabled: 'Validar código',
        normal: 'Validar código',
        error: 'Código no valido',
        valid: 'Código valido'
      }
    },
    logIn: 'Iniciar Sesión',
    alreadyHaveAnAccount: '¿Ya tienes tu cuenta?',
    createYourAccount: 'Crea tu cuenta en CBX',
    signUpHelper:
      'Realiza tus compras de manera más rápida creando tu cuenta. Además podrás accesar a tu historial de compra, actualizar datos y agregar acompañantes de viaje.',
    acceptTermsRegister: ['Al marcar esta casilla y crear un perfil de CBX, aceptas nuestros ', <a target="_blank" rel={"noopener noreferrer"} style={{color:"#ef60a3"}} href="/es/terms">Términos y condiciones</a>,'. Además, comprendes y reconoces que tu información será utilizada y tratada como se describe en nuestra ', <a style={{color: '#ef60a3'}} target="_blank" rel={"noopener noreferrer"} href="/es/privacy">Política de privacidad</a>, '.'],
    checkboxDonate: 'Sí, me gustaría donar $1 dólar a la campaña de CBX Warm Hearts Warm Meals para apoyar la lucha contra el hambre en Tijuana en colaboración con ',
    donateTitle: '¡Sí! Me gustaría donar',
    donateText: 'para brindar seguridad alimenticia a familias vulnerables en la frontera entre EE. UU. y México a través de la campaña de donaciones ',
    donateText2: 'Warm Hearts Warm Meals',
    modalDonate: 'Durante el mes de septiembre, CBX y This is About Humanity se han comprometido a igualar las donaciones recibidas hasta $20,000 USD. Con tu aportación juntos apoyaremos a varias organizaciones sin fines de lucro en Tijuana quienes proveen alimento a poblaciones vulnerables.',
    signUp: 'Crear cuenta',
    country: 'País',
    errorMessage:
      'Hubo un problema con el sistema de pagos, por favor intenta nuevamente en unos minutos. En caso que no logres completar la compra, por favor contáctenos.',
    errorCreditCard:
      'Hubo un problema con tu método de pago, por favor intenta nuevamente.',
    errorInput: 'Por favor verifica que tus datos estén correctos.',
    errorTickets:
      ['Se ha generado un problema técnico al enviar su boleto CBX. Por favor contáctenos vía correo electrónico a: ', <a style={{ color: 'rgb(239, 96, 163)' }} href="mailto:support@crossborderxpress.com">support@crossborderxpress.com</a>, ' con el fin de revisar su transacción y el error generado.'],
    shoppingError:
      '¡Ha ocurrido un error!',
    errorConnection:
      'Se ha presentado un error en su transacción, su cobro no se ha realizado por favor intente nuevamente.',
    downloadTicketInfo:
      'Una copia de tu boleto CBX ha sido envíada a: ',
    quantity: 'Cantidad',
    people: 'Personas',
    contactInformation: 'Información de contacto',
    purchaseSummary: 'Resumen de compra',
    flightInformation: 'Información de vuelo',
    paymentInformation: 'Información de pago',
    departDate: 'Fecha de Salida',
    returnDate: 'Fecha de Regreso',
    cancelLabel: 'Cancelar',
    myTrip:"Mi viaje",
    updateTicket: "Actualizar Información",
    ticketUpdateSuccessful: 'La información se ha actualizado con éxito',
    ticketUpdateError: 'Ocurrió un error al actualizar la información. Por favor intente de nuevo más tarde.',
    continueLabel: 'Continuar',
    originLabel: 'Desde',
    destinationLabel: 'Hacia',
    LoginButton: 'Ingresar',
    createCBXAccount: 'Crea tu cuenta CBX',
    signInComplementaryText: 'Y haz tus compras de manera más rápida',
    buyLabel: 'Comprar',
    name: {
      placeHolder: 'Nombre',
      label: 'Nombre'
    },
    rfc: {
      placeHolder: 'RFC',
      label: 'RFC'
    },
    lastName: {
      placeHolder: 'Apellidos',
      label: 'Apellidos'
    },
    email: {
      placeHolder: 'Correo electrónico',
      label: 'Correo electrónico'
    },
    emailCheck: {
      placeHolder: 'Confirma tu correo electrónico',
      label: 'Confirmación de correo electrónico'
    },
    zipCode: {
      placeHolder: 'Código postal',
      label: 'Código postal'
    },
    phone: {
      placeHolder: 'Teléfono',
      label: 'Teléfono'
    },
    creditCardHolder: {
      placeHolder: 'Nombre impreso en la tarjeta',
      label: 'Nombre en la tarjeta'
    },
    creditCard: {
      placeHolder: '4111 1111 1111 1111',
      label: 'Número de tarjeta'
    },
    ccv: {
      placeHolder: 'CCV',
      label: 'CCV'
    },
    expirationDate: {
      placeHolder: 'MM / AA',
      label: 'Fecha de expiración'
    },
    creditCardZipCode: {
      placeHolder: '11111',
      label: 'Código Postal'
    },
    creditCardZipCodeSmall: {
      placeHolder: 'CP',
      label: 'CP'
    },
    isInvalid: ' es inválido.',
    isIncomplete: ' está incompleto.',
    acceptTerms: {
      label: 'Acepto los Términos y Condiciones de CBX.'
    },
    acceptMailInfo: {
      label:
        'Deseo recibir información adicional y promociones especiales de CBX por correo.'
    },
    password: {
      placeHolder: 'Contraseña',
      label: 'Contraseña'
    },
    checkPassword: {
      placeHolder: 'Confirmar contraseña',
      label: 'Confirmar contraseña'
    },
    shoppingLabels: {
      transaction: 'ID de compra',
      detail: 'Tipo de Boleto',
      type: 'Viaje',
      passengers: 'Pasajeros',
      date: 'Fecha',
      product: 'Producto',
      invoice: 'Facturar',
      price: 'Costo',
      ticket: 'Boleto',
      roundtrip: 'Redondo',
      oneway: 'Sencillo',
      single: 'Individual',
      family: 'Familiar',
      typeOptions: [
        {
          name: 'Tipo',
          value: ''
        },
        {
          name: 'Sencillo',
          value: 'oneway'
        },
        {
          name: 'Redondo',
          value: 'roundtrip'
        }
      ],
      detailOptions: [
        {
          name: 'Detalle',
          value: ''
        },
        {
          name: 'Individual',
          value: 'single'
        },
        {
          name: 'Familiar',
          value: 'family'
        }
      ]
    },
    invoice: {
      sendMessage: 'Gracias, hemos recibido tu información. Este no es un sistema automatizado por lo que la factura se enviará en un período de 5 a 7 días hábiles.',
      error: 'Hubo un error con tu información',
      title: 'Facturación',
      instructions:
        'Para tramitar tu factura requerimos los siguientes datos tal como aparecen en tu cédula fiscal:',
      terms:
        'Te recordamos que tienes 15 días naturales para solicitar tu factura.',
      rfc: {
        label: 'RFC',
        placeHolder: 'RFC'
      },
      company: {
        label: 'Nombre o Razón Social (persona física o moral)',
        placeHolder: 'Nombre o Razón Social'
      },
      ticketNumber: {
        label: 'Número de boleto de CBX',
        placeHolder: 'Número de boleto de CBX'
      },
      ticketDate: {
        label: 'Fecha de boleto',
        placeHolder: 'DD / MM / YY'
      },
      ticketPrice: {
        label: 'Precio del boleto',
        placeHolder: 'Precio del boleto'
      },
      saleId: {
        label: 'Recibo de compra (Sales ID)',
        placeHolder: 'Recibo de compra'
      },
      purchaseTicket: {
        label: 'Comprobante de pago',
        placeHolder: 'Comprobante de pago'
      },
      company_zip_code: {
        label: 'Código postal del domicilio fiscal',
        placeHolder: 'Código postal'
      },
      receipt: {
        label: 'Recibo',
        placeHolder: 'Recibo'
      },
      paymentMethod: {
        label: 'Método de pago',
        options: [
          {
            name: 'Selecciona el método de pago',
            value: ''
          },
          {
            name: 'Efectivo',
            value: 'cash'
          },
          {
            name: 'Tarjeta de crédito',
            value: 'creditCard'
          },
          {
            name: 'Tarjeta de débito',
            value: 'debitCard'
          }
        ]
      },
      businessType: {
        label: 'Régimen fiscal',
        options: [
          {
            name: 'Selecciona el régimen fiscal',
            value: ''
          },
          {
            name: 'General de Ley Personas Morales',
            value: '601 - General de Ley Personas Morales'
          },
          {
            name: 'Personas Morales con Fines no Lucrativos',
            value: '603 - Personas Morales con Fines no Lucrativos'
          },
          {
            name: 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
            value: '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios'
          },
          {
            name: 'Arrendamiento',
            value: '606 - Arrendamiento'
          },
          {
            name: 'Demás ingresos',
            value: '608 - Demás ingresos',
          },
          {
            name: 'Consolidación',
            value: '609 - Consolidación',
          },
          {
            name: 'Residentes en el Extranjero sin Establecimiento Permanente en México',
            value: '610 - Residentes en el Extranjero sin Establecimiento Permanente en México'
          },
          {
            name: 'Ingresos por Dividendos (socios y accionistas)',
            value: '611 - Ingresos por Dividendos (socios y accionistas)',
          },
          {
            name: 'Personas Físicas con Actividades Empresariales y Profesionales',
            value: '612 - Personas Físicas con Actividades Empresariales y Profesionales',
          },
          {
            name: 'Ingresos por intereses',
            value: '614 - Ingresos por intereses',
          },
          {
            name: 'Sin obligaciones fiscales',
            value: '616 - Sin obligaciones fiscales',
          },
          {
            name: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
            value: '620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
          },
          {
            name: 'Incorporación Fiscal',
            value: '621 - Incorporación Fiscal',
          },
          {
            name: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
            value: '622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
          },
          {
            name: 'Opcional para Grupos de Sociedades',
            value: '623 - Opcional para Grupos de Sociedades',
          },
          {
            name: 'Coordinados',
            value: '624 - Coordinados',
          },
          {
            name: 'Régimen Simplificado de Confianza',
            value: '626 - Régimen Simplificado de Confianza',
          },
          {
            name: 'Hidrocarburos',
            value: '628 - Hidrocarburos',
          },
          {
            name: 'Régimen de Enajenación o Adquisición de Bienes',
            value: '607 - Régimen de Enajenación o Adquisición de Bienes',
          },
          {
            name: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales',
            value: '629 - De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales',
          },
          {
            name: 'Enajenación de acciones en bolsa de valores',
            value: '630 - Enajenación de acciones en bolsa de valores',
          },
          {
            name: 'Régimen de los ingresos por obtención de premios',
            value: '615 - Régimen de los ingresos por obtención de premios'
          }
        ]
      },
    },
    savingData: 'Guardando tus datos, espera un momento...',
    savedData: 'Tus datos han sido guardados',
    startDate: 'Entrada',
    endDate: 'Salida',
    startTime: 'Hora',
    endTime: 'Hora',
    parkingLabel: 'Reserva tu estacionamiento',
    parkingButton: 'Reservar',
    parking: 'Estacionamiento',
    ticket: 'Ticket',
    numberOfTickets:'Selecciona número de boletos',
    viewMore: 'Ver más',
    confirmParkingPage:'Confirma la información del estacionamiento',
    parkingSelectDatesLabel:'Selecciona fechas',
    passengersLabel: 'Pasajeros',
    shuttleSelectDatesLabel:'Confirma la información del shuttle',
    shuttleFormDescription:'Favor de presentar su reservación impresa al conductor con su identificación oficial, al abordar.',
    startFormParking:'Inicio',
    endFormParking:'Fin',
    addRemovePlaces:'Agregar / quitar otro auto',
    selecDateLabel:'Selecciona fecha y horario de salida',
    vehicleInformation:'Información de reserva del vehículo ',
    vehiclesNo: 'Espacios reservados',
    maker:'Fabricante',
    model:'Modelo',
    year:'Año',
    color:'Color',
    state:'Estado:',
    license:'Placa',
    editParking:'Editar',
    continueParking:'Continuar comprando',
    selectLot:'Elige lote de estacionamiento',
    lot:'Lote',
    selectLabel:"Seleccionar",
    day:'día',
    infoLot:'Tarifas diarias sujetas a cambios sin previo aviso.',
    parkingSpaceLot:'Plazas de estacionamiento:',
    manageTicketsTitle :"Gestiona tu viaje",
    typeInformationLabel:"Escribe la siguiente información:",
    purchaseNumberLabel:"Número de compra",
    forgotPurchaseNumber:"¿Olvidó su número de compra?",
    shoppifasterLabel:"Y haz que tu experiencia de compra sea más rápida",
    enter:"Ingresar",
    cancel:"Cancelado",
    myTRipLable:" Mi viaje",
    carRental:'Renta de autos',
    shuttle:"Shuttle",
    proceedCheckout: "Realizar pedido",
    missingSomething:"¿Necesitas algo?",
    addItems: "Sigue agregando artículos a tu carrito de compra",
    emptyCart: "El carrito está vacío.",
    emptyAddItems: "Agrega artículos a tu carrito de compra",
    diferentDatesLabel:"Atención",
    diferentDatesSubTitle:"La fecha de viaje y la fecha de reserva de estacionamiento no coinciden. Asegúrate de que las fechas sean correctas.",
    apply:"Aplicar",
    remove:"Eliminar",
    purchase:"Comprar",
    thankYou:"¡Gracias!",
    successMessage:["Agradecemos tu compra.", <br/>, "Recibirás una confirmación por correo electrónico con todos tus datos."],
    forgotSomething:"Olvidaste algo?",
    keepAdding:"Agrega productos a tu carrito",
    download:"Descarga tu boleto",
    downloadParking:"Descarga tu boleto (Estacionamiento)",
    downloadShuttle:"Descarga tu boleto (Shuttle)",
    downloadWheels:"Descarga tu boleto (Transporte Privado)",
    wheelsDisclaimer: "El servicio de transporte Wheels es operado por Mexicoach Inc., TCP 0036804. CBX no es un TCP y no es dueño, ni opera ningún autobús o vehículo a cambio de compensación o contratación.",
    returnHome:"Regresar al inicio",
    passenger:"Pasajero",
    baggage: "Equipaje",
    shuttleSelectSeatsLabel: "Seleccionar asientos",
    shuttleBaggageLabel: "Elija # de maletas",
    ticketLabel: "Ticket",
    travelPurpose:"Motivo de Viaje",
    confirm:"Confirmar",
    addToCart:"Agregar al carrito",
    ticketStep: "Ticket",
    passengerInformation: "Información de pasajero",
    addOns: "Add-ons",
    addOnsSubtitle:"Agregar otros productos",
    checkout: "Finalizar compra",
    reserve_parking: "Reserva tu estacionamiento",
    reserve_shuttle: "Reserva tu shuttle",
    requestProcessing: "Procesando...",
    requestDoNotClose: "Por favor no recargue la página",
    requestSearching: "Buscando ticket...",
    titleTripLogin:"Gestiona tu viaje",
    typeInformation:"Escriba la siguiente información",
    purchaseNumber:"Número de compra",
    identityLabel: 'Correo electrónico, apellido, o teléfono',
    forgotInformation:"Olvidó su número de compra",
    createAccount:"Crear una cuenta CBX",
    fasterShoppingLabel:"Haz tus compras más rápido",
    areYouSureCancel:"¿Estás seguro de que deseas cancelar este artículo?",
    cancellingHoursLabel:"Si cancelas hasta 24 horas antes del inicio de tu reservación, obtendrás la devolución del 100% del monto pagado. Si tu cancelación es dentro de las 24 horas anteriores al inicio de tu reserva, podrás recibir un reembolso parcial calculado automáticamente.",
    returnLabel:"Regresar",
    cancelItem:"Cancelar este artículo",
    successCancellationTitle:"Tu cancelación ha sido exitosa",
    successCancellationDescription:"Recibirás un correo con la información",
    ok:"Aceptar",
    showErrorCancellationTitle:"Tu cancelación no puedo ser procesada ",
    showErrorCancellationDescription:"Para cualquier duda escribenos a ",
    parkingLabelCancel:"Estacionamiento",
    days:"Día",
    vehiclesLabel:"Vehículo",
    startDateLabel:"Inicio",
    startDateLabelTickets:"De",
    endDateLabelTickets:"Para",
    endDateLabel:"Fin",
    cancelTheItem:"Cancelar el artículo",
    hi:"Hola,",
    invalidEmail:"Correo inválido",
    errorCredentials:'Credenciales inválidas',
    PurchaseDetailsLabel:"Detalles de la compra",
    mainContact:"Contacto principal ",
    dateOfSale:"Fecha de venta",
    salesId:"ID de venta",
    cardNumber:"Número de tarjeta",
    total:"Total",
    contactUs:"Contactanos",
    downloadTicket:"Descargar boleto",
    downloadTicketParking: 'Descargar estacionamiento',
    itemsInMyCart: 'Productos en carrito',
    moreProducts: 'Otros de nuestros productos',
    sportsNotAvailableTitle: 'Por favor, cambia tu selección',
    sportsNotAvailableLabel: 'Las reservas para valet están disponibles en todo momento, pero las reservas en los lotes designados están agotadas para las fechas seleccionadas. También ofrecemos opciones de estacionamiento y servicios de valet en sitio.',
    sportsNotAvailableButton: 'Ver Nuestros Estacionamientos',
    assistPassName: 'Nombre',
    assistPassLastName: 'Apellido',
    assistPassGender: 'Genero',
    assistPassPhone: 'Teléfono',
    assistPassAge: 'Edad',
    assistPassDate: 'Fecha',
    assistPassFightNumber: 'Número de vuelo',
    assistPassAirline: 'Aerolinea',
    assistPassOrigin: 'Origen',
    assistPassDestination: 'Destino',
    assistPassTutorName: 'Nombre',
    assistPassTutorLastName: 'Apellido',
    assistPassTutorPhone: 'Télefono',
    assistPassTutorEmail: 'Correo',
    visa: 'Visa',
    samPermit: 'SAM',
    fmmPermit: 'FMM',
    passport: 'Passport',
    permit94: 'I-94 permit',
    unForm: 'UNMR formulario',
    filesToSubmit: 'Archivos por subir',
    tutorDescription: 'Información del tutor',
    flightDescription: 'Información del vuelo',
    onlyVolaris: 'Servicio solo aplica con Volaris',
    male: 'Masculino',
    female: 'Femenino',
    unspecified: 'No especificado',
    genderSelected: 'El género seleccionado debe ser idéntico al que aparece en su pasaporte / documentos de viaje oficiales.',
    ageRangeunavailable: 'Para menores de edad, de entre 13 y 17 años. El servicio no está disponible fuera del rango de estas edades',
    emptyFile: 'Sin archivo',
    fileSelected: 'Archivo seleccionado!',
    collapse:'Colapsar',
    expand:'Expandir',
    search:'Buscar',
    whatCanWeHelpYouFind:'¿Qué podemos ayudarte a buscar?',
    //shuttle
    selectTrip:"Seleccionar viaje",
    selectTripBack:"Seleccionar viaje de regreso",
    notInclude:"No incluye tarifas aplicables.",
    details:"Detalles",
    serviceProvider:"Proveedor de servicio",
    standarFare:"Tarifa estándar",
    select: "Seleccionar",
    noTransfers: "SIN TRANSBORDO",
    transfers: " TRANSBORDO",
    withTransfers: "CON TRANSFERENCIAS",
    depart: 'Salida',
    arrival :"Llegada",
    person: "por persona",
    selectYourSeat: "Selecciona tu asiento",
    avalaibleSeat: "Asientos disponibles: ",
    available:"Disponible",
    occupied:"Ocupado",
    selectSeat:"Seleccionar asiento",
    seat :"Asiento",
    attention:"Atención",
    shuttleNotAvailableTitle:'Lo sentimos no hay rutas disponibles en las fechas seleccionadas.',
    shuttleNotAvailableLabel:'Por favor intente con otras fechas. ',
    warnText:"Aún no se seleccionan todos los asientos requeridos",
    loading: 'Cargando',
    permit94Site: 'Visita el sitio oficial de I-94',
    unFormSite: 'Descarga la forma UNMR',
    samPermitSite: 'Visita el sitio oficial de SAM',
    fmmPermitSite: 'Visita el sitio oficial de FMM',
    return: 'Atras',
    textShuttleQuickBook: 'Otay-Tijuana Venture, LLC no es un Charter-Party Carrier (TCP) ni Passenger Stage Corporation (PSC) y no es dueño ni opera ningún camión, shuttle o vehículo de alquiler o por el que reciba compensación.',
    assistedPassDescription: 'Llena los campos con la información de identificación oficial o documentos de viaje con los que va a cruzar',
    notarizedPermit: 'Carta Notariada',
    mex: 'Mexicano',
    usa: 'Americano',
    other: 'Otro',
    nationality: 'Nacionalidad',
    IdTutor: 'ID Tutor',
    howWorks: 'Lee mas sobre como funciona',
    unaccompaniedTeen: ' Adolescente sin Acompañante',
    assistedPass: ' Pase Asistido',
    convertion: '*El cargo final se efectuará en USD al tipo de cambio oficial de Banxico.',
    reserveBundles: 'Reserva tu paquete',
    bundles: 'Paquetes',
    tickPlusShuttle: '25% menos ticket + shuttle',
    configure: 'Configurar',
    wheelsSelector: 'Transporte Privado',
    reserve_wheels: 'Reserva transporte privado',
    confirmWheelsPage: 'Reserva Transporte Privado',
    selectedInsurance: 'Si elegiste la protección médica de viaje, recibirás un correo electrónico por separado con tu póliza.'

  }
};
